<template>
    <div class="homepage backoffice" :key="key">

        <div class="backoffice--sidebar">
            <div class="backoffice--sidebar--action">
                <div class="backoffice--sidebar--icon" @click="save_quote" title="salva"><font-awesome-icon size="lg" icon="save"/></div>
            </div>
            <div class="backoffice--sidebar--action">
              <div class="backoffice--sidebar--icon" @click="validate_quote" title="verifica"><font-awesome-icon size="lg" icon="check"/></div>
            </div>
            <div class="backoffice--sidebar--action">
                <div class="backoffice--sidebar--icon" @click="send_for_review" title="invia in revisione"><font-awesome-icon size="lg" icon="pen"/></div>
            </div>
            <div class="backoffice--sidebar--action">
                <div class="backoffice--sidebar--icon" @click="send_for_publish" title="pubblica prodotto"><font-awesome-icon size="lg" icon="globe"/></div>
            </div>
        </div>

        <b-container fluid>
            <b-row>
                <b-col cols="10" lg="12">
                    <div class="backoffice--head" v-if="Object.keys(quote).length > 0">
                        <div class="status">
                            <b-badge variant="info">R-{{ request_id }}</b-badge>
                            &nbsp;
                            <b-badge :variant="status_variant">{{ quote.quote_status }}</b-badge>
                            &nbsp;
                            <b-badge :variant="(attention_required)? 'warning' : 'info'" @click="set_attention_required()" :title="(attention_required)? 'metti in attesa' : 'metti da lavorare'">{{ (attention_required)? 'da lavorare' : 'in attesa' }}</b-badge>
                        </div>
                        <div class="backoffice--actions">
                            <div class="backoffice--action" @click="add_service('flight')">
                                <div class="backoffice--action--icon"><font-awesome-icon size="sm" icon="plane"/></div>
                                <div class="backoffice--action--text">+ Volo</div>
                            </div>
                            <div class="backoffice--action" @click="add_service('transfer')">
                                <div class="backoffice--action--icon"><font-awesome-icon size="sm" icon="bus"/></div>
                                <div class="backoffice--action--text">+ Trasferimento</div>
                            </div>
                            <div class="backoffice--action" @click="add_service('overnight')">
                                <div class="backoffice--action--icon"><font-awesome-icon size="sm" icon="bed"/></div>
                                <div class="backoffice--action--text">+ Pernottamento</div>
                            </div>
                            <div class="backoffice--action" @click="add_service('package')">
                              <div class="backoffice--action--icon"><font-awesome-icon size="sm" icon="globe"/></div>
                              <div class="backoffice--action--text">+ Pacchetto</div>
                            </div>
                            <div class="backoffice--action">
                                <div class="backoffice--action--icon"><font-awesome-icon size="sm" icon="hospital-symbol"/></div>
                                <div class="backoffice--action--text">+ Assicurazione</div>
                                <b-form-select size="sm" v-model="insurance_model" @change="(value) => {
                                        this.insurance_model = value
                                        this.add_service('insurance')
                                    }">
                                    <b-form-select-option value="''">
                                        Nessun modello
                                    </b-form-select-option>
                                    <b-form-select-option v-for="(model,key,index) in insurances" v-bind:key="index" :value="key">
                                        {{ key }}
                                    </b-form-select-option>
                                </b-form-select>
                            </div>
                            <!--
                            <div class="backoffice--action" @click="add_service('insurance')">
                                <div class="backoffice--action--icon"><font-awesome-icon size="sm" icon="hospital-symbol"/></div>
                                <div class="backoffice--action--text">+ Assicurazione</div>
                            </div>
                            -->
                            <div class="backoffice--action" @click="add_service('generic')">
                                <div class="backoffice--action--icon"><font-awesome-icon size="sm" icon="question"/></div>
                                <div class="backoffice--action--text">+ Generico</div>
                            </div>
                            <div class="backoffice--action modal-request" v-b-modal.modal-request>
                                Vedi richiesta utente
                                <b-modal id="modal-request" title="Richiesta utente" size="lg">
                                  <b-button @click="open_user_request()">Apri su altro tab</b-button>
                                  <user-request :user_request="user_request" :pax="pax"/>
                                </b-modal>
                            </div>
                            <div class="backoffice--action">
                              <history :request_id="request_id" />
                            </div>
                            <div class="backoffice--action">
                              <request-messages :request_id="request_id" />
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <div class="backoffice--content">
                        <quote-details :details="quote.details" :request_id="request_id" />
                        <div v-for="( service ) in quote.services" v-bind:key="service.service_index" >
                            <service :service="service" @swapped="swapped_services"/>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>    
</template>

<script>
import Vue from 'vue'
import { add_service_to_quote } from '@/quote'
import {
    api_save_quote,
    api_validate_quote,
    send_quote_for_review,
    send_quote_for_publish,
    get_active_quote,
    post_heartbeat,
    api_set_attention_required
} from '@/api'
import Service from '@/components/blocks/service'
import QuoteDetails from '@/components/blocks/quote-details'
import UserRequest from '@/components/blocks/user-request'
import RequestMessages from '@/components/blocks/request-messages'
import History from '@/components/blocks/history'

export default {
    name: 'new-quote',
    components: {
        'service': Service,
        'quote-details': QuoteDetails,
        'user-request': UserRequest,
        'request-messages': RequestMessages,
        'history': History,
    },    
    props: {
        request_id: String,
    },
        watch: { 
            quote: function(newVal, oldVal) {
                this.log('WATCH!')
                this.log('Prop changed: ', newVal, ' | was: ', oldVal)
            }
    },
    computed: {
        quote: {
            get() {
                return this.$store.state.quote
            },
            set(value)
            {
                this.$store.commit('set_quote', value)
            },
        },
        status_variant: {
            get(){
                if(this.quote.quote_status == 'assigned') return 'warning'
                if(this.quote.quote_status == 'declined') return 'danger'
                if(this.quote.quote_status == 'accepted') return 'danger'
                if(this.quote.quote_status == 'inReview') return 'success'
                if(this.quote.quote_status == 'published') return 'success'
                if(this.quote.quote_status == 'booked') return 'success'
                return 'info' // created|assigned|inReview e published
            },
            set(){}
        }
    },
    data() {
        return {
            user_request: {},
            pax: {}, // quelli "in arrivo" dallo shop
            key: 1,
            insurances: Vue.prototype.$config.config.contents.insurances,
            insurance_model: '',
            hearbeat_timeout: null,

            attention_required: false,
        }
    },
    beforeMount()
    {
    },
    mounted()
    {

        this.get_active_quote()

        post_heartbeat({request_id: this.request_id}) // pingo subito

        if(Vue.prototype.$config.config.heartbeat_seconds && Vue.prototype.$config.config.heartbeat_seconds > 0) {

          this.heartbeat_timeout = this.heartbeat_ping()

        }


    },
    destroyed(){
      clearTimeout(this.heartbeat_timeout)
    },
    methods:
    {
        swapped_services()
        {
            this.key++
        },

        get_active_quote(){
          get_active_quote({
            request_id: this.request_id
          })
              .then( response => {
                this.quote = response.quote
                this.user_request = response.user_request
                this.user_request.messages = (response.messages)? response.messages : [] // TODO
                this.pax = (response.quote.pax)? response.quote.pax : {}
                this.attention_required = (response.attention_required)? true : false
                this.key++
              })
        },

        heartbeat_ping(){
          
          let _this = this
          return setTimeout(function () {

            post_heartbeat({request_id: _this.request_id}) // pingo ogni x
                .then(
                    (success) => {
                      (success)
                      _this.heartbeat_timeout = _this.heartbeat_ping()
                    },

                    (error) => {
                      (error)
                      _this.log('heartbeat_ping error')
                    }
                )

          }, Vue.prototype.$config.config.heartbeat_seconds * 1000);

        },
      
        add_service(type)
        {
            let service = add_service_to_quote(this.quote,type)

            if(type == 'insurance' && this.insurance_model !== '')
            {
                let model = this.insurances[this.insurance_model]
                let updated_service = { 
                    ...service,
                    ...model
                }
                service = updated_service
            }

            this.quote.services.push(service)
        },

        update_quote_general_info()
        {
            this.$store.commit('set_quote_general_info', {
                request_id: this.quote.request_id,
                user_id: this.quote.user_id,
                created_at: this.quote.created_at,
                details: this.quote.details,
            })
        },

        save_quote()
        {

            let payload = {
                request_id: this.$store.state.quote.request_id,
                quote: this.$store.state.quote
            }
            this.log('[backoffice-sidebar] - save_quote()')
            this.log(payload)
            api_save_quote(payload)
                .then(
                    (success) => {
                      (success)
                      Vue.$toast.success('salvato')
                    }
                )
        },

        validate_quote()
        {

          let payload = {
            request_id: this.$store.state.quote.request_id,
            quote: this.$store.state.quote
          }
          this.log('[backoffice-sidebar] - validate_quote()')
          api_save_quote(payload)
              .then(

                  (success) => {
                    (success)

                    Vue.$toast.success('salvato')

                    payload = {
                      request_id: this.$store.state.quote.request_id,
                      quote: this.$store.state.quote,
                      //quote_status: 'inReview',
                    }

                    api_validate_quote(payload)
                        .then(

                            (success) => {
                                (success)
                                Vue.$toast.success('VALIDO')
                            },

                            (error) => {
                                (error)
                                Vue.$toast.error('NON VALIDO')
                            }
                        )


                  }, // api_save_quote success


              )
        },

        send_for_review()
        {

            if(!confirm('Vuoi inviare questa proposta per la revisione da parte dell\'utente?')) return

            if(!this.validate_for_review()){
              Vue.$toast.error('impossibile mandare in revisione')
              return
            }

            let payload = {
                request_id: this.$store.state.quote.request_id,
                quote: this.$store.state.quote
            }

            api_save_quote(payload)
                .then(

                    (success) => {

                        (success)
                        Vue.$toast.success('salvato')

                        payload = {
                            request_id: this.$store.state.quote.request_id,
                            //quote: this.$store.state.quote,
                            //quote_status: 'inReview',
                        }

                        send_quote_for_review(payload)
                            .then(

                                (success) => {
                                  (success)

                                  Vue.$toast.info('inviato in revisione')

                                  this.$router.push({
                                      name: 'requests'
                                  })

                                },

                                (error) => {
                                    (error)
                                    Vue.$toast.error('non inviato in revisione')
                                }
                            )


                    }, // api_save_quote success

                    (error) => {
                        (error)
                        Vue.$toast.error('non salvato')
                    }
                )

        },

        send_for_publish(){

            if(this.quote.quote_status == 'published'){

              if(!confirm('Prodotto già pubblicato, vuoi modificarlo?')) return

            }else{

              if(!confirm('Vuoi pubblicare questo prodotto?')) return

            }


            if(!this.validate_for_publish()){
              Vue.$toast.error('impossibile pubblicare')
              return
            }


            let payload = {
                request_id: this.$store.state.quote.request_id,
                quote: this.$store.state.quote
            }

            api_save_quote(payload)
                .then(

                    (success) => {

                        this.result = success.data.result
                        Vue.$toast.success('salvato')

                        payload = {
                            request_id: this.$store.state.quote.request_id,
                            //quote: this.$store.state.quote,
                            //quote_status: 'inReview',
                        }

                        send_quote_for_publish(payload)
                            .then(
                                (success) => {
                                  (success)

                                    Vue.$toast.info('pubblicato ' + success.data.productCode)
                                    this.$router.push({
                                        name: 'requests'
                                    })

                                },

                                (error) => {
                                  (error)
                                  Vue.$toast.error('non pubblicato')
                                }
                            )

                    },

                    (error) => {
                        (error)
                        Vue.$toast.error('non salvato')
                    }
                )
        },

        validate_for_review(){
            if(!this.can_review_by_status()){
              Vue.$toast.error('Non è possibile mandare in revisione una proposta con stato: ' + this.quote.quote_status)
              return false
            }

            // TODO validazione quote?
            return true
        },

        validate_for_publish(){
            if(!this.can_publish_by_status()){
              Vue.$toast.error('Non è possibile pubblicare una proposta con stato: ' + this.quote.quote_status)
              return false
            }

            // TODO validazione quote??
            return true
        },

        log_quote(){
          this.log(this.quote)
        },

        open_user_request(){

          let routeData = this.$router.resolve({name: 'view_user_request' });
          window.open(routeData.href, '_blank');

        },

        can_review_by_status(){
          let reviewable_statuses = ['assigned', 'inReview', 'declined', 'rejected']
          return reviewable_statuses.includes(this.quote.quote_status)
        },

        can_publish_by_status(){
          let publishable_statuses = ['assigned', 'accepted', 'published'] // assigned per pubblicare da "crea nuovo"
          return publishable_statuses.includes(this.quote.quote_status)
        },

        set_attention_required(){

          api_set_attention_required({
            request_id: this.request_id,
            attention_required: (this.attention_required == 0)? 1 : 0 // deve invertire il valore
          })
              .then(
                  (success) => {
                    this.attention_required = (success.data.attention_required == 1)? true : false
                  },
                  () => {
                    Vue.$toast.error('error')
                  }
              )

        }
    },
}
</script>


<style lang="scss">
    .backoffice
    {
        &--sidebar
        {
            margin-top:$grid-gutter-width;
            width:80px;
            position:fixed;
            top:$backoffice-head-height;
            left:0;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            padding-left: $grid-gutter-width/2;
            &--action
            {
                width:100%;
                display:inline-flex;
                align-items:center;
                justify-content: center;
                padding:0.5rem 1rem;
                margin-bottom:1rem;
                border:2px solid $primary;
                color:$primary;
                border-radius: $border-radius;
                transition:$transition-base;
                font-size: 20px;
                cursor: pointer;
                &:hover
                {
                    background: $primary;
                    color: $white;
                }
                &--icon
                {
                }
            }
        }
        &--content
        {
            margin-top:40px;
        }
        &--head
        {
            position:fixed;
            z-index: 1;
            top:$backoffice-head-height;
            left:$backoffice-sidebar-width + $grid-gutter-width/2;
            right:$grid-gutter-width/2;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding:$grid-gutter-width/2 0 $grid-gutter-width/2 0;
            background:$white;
            .form-group
            {
                margin-right:1rem;
                margin-bottom:0;
            }
            label
            {
                margin-bottom:0;
                font-size: $font-size-sm;
            }
        }
        .status
        {
            color:$info;
            span
            {
                display:inline-block;
                padding-right:10px;
                font-size: 12px;
                text-transform:uppercase;
                font-weight: bold;
            }
        }
        .modal-request
        {
            border-color:$info;
            background:$info;
            color:$white;
            text-transform: uppercase;
            font-weight: bold;
        }
        &--quote
        {
            display:flex;
        }
        &--actions
        {
            display:flex;
            align-items:center;
            justify-content: flex-start;
        }
        &--action
        {
            font-size:14px;
            display:inline-flex;
            align-items:center;
            justify-content: flex-end;
            padding:0.25rem 0.75rem;
            margin-left:1rem;
            border:1px solid $secondary;
            color:$secondary;
            border-radius: $border-radius;
            transition:$transition-base;
            background:$white;
            cursor: pointer;
            &:hover
            {
                background: $secondary;
                color: $white;
            }
            &:first-child
            {
                margin-left:0;
            }
            &--icon
            {
                margin-right:0.5rem;
            }
        }   
        
        .backoffice--action
        {
            position:relative;
            .custom-select
            {
                cursor:pointer;
                border:0;
                position:absolute;
                left:0;
                right:0;
                top:0;
                bottom:0;
                max-width: 100%;
                background:transparent;
                z-index: 1;
                padding: 0;
                height: auto;
                width: auto;
                color:transparent;
                option
                {
                    color:$text;
                }
            }
        }
    }

    .toggle
    {
        width:40px;
        height:40px;
        svg
        {
            transform:rotate(-90deg);
            transition:$transition-base;
        }  
        &.not-collapsed svg
        {
            transform:rotate(0deg);
        }          
    }

    label
    {
        color:$secondary;
        font-weight: bold;
        font-size: 14px;
        display:flex;
        align-items: center;
        min-width:100%;
    }

    .input-group-append button
    {
        font-size:12px;
        padding:0 8px;
    }
    
</style>
